/* VOLTIGE — moteur commun des maisons : panier AJAX partagé, variantes, galerie, menu, apparition */
(function () {
  "use strict";
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const C = window.LUSTRA || {};

  /* ---------- Monnaie (format Shopify) ---------- */
  function money(cents) {
    const f = C.moneyFormat || "{{amount_with_comma_separator}} €";
    const n = cents / 100, a2 = n.toFixed(2);
    return f
      .replace(/\{\{\s*amount\s*\}\}/, a2)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(n))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, a2.replace(".", ","))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, Math.round(n))
      .replace(/\{\{\s*amount_with_space_separator\s*\}\}/, a2.replace(".", ","))
      .replace(/\{\{\s*amount_no_decimals_with_space_separator\s*\}\}/, Math.round(n));
  }

  /* ---------- Panier ---------- */
  const openCart = () => document.body.classList.add("cart-open");
  const closeCart = () => document.body.classList.remove("cart-open");

  async function fetchCart() { const r = await fetch(C.routes.cartJson, { headers: { Accept: "application/json" } }); return r.json(); }

  function renderCart(cart) {
    $$(".cart-count").forEach(el => { el.textContent = cart.item_count; if (cart.item_count) el.removeAttribute("data-zero"); else el.setAttribute("data-zero", ""); });
    const box = $("#cart-items"); if (!box) return;
    if (!cart.items.length) {
      box.innerHTML = `<div class="cart__empty"><p>${box.dataset.empty || "Votre panier est vide."}</p><a class="btn btn--primary" href="${box.dataset.shop || "/"}">${box.dataset.cta || "Découvrir"}</a></div>`;
    } else {
      box.innerHTML = cart.items.map(it => `<div class="cart-item">
        <img src="${it.image ? it.image.replace(/(\.[a-z]+)(\?.*)?$/i, "_160x$1$2") : ""}" alt="">
        <div>${it.vendor ? `<div class="vt-m">${it.vendor}</div>` : ""}<div class="t">${it.product_title}</div><div class="v">${it.variant_title || ""}</div>
          <div class="qty"><button type="button" data-change="${it.key}" data-qty="${it.quantity - 1}" aria-label="Moins">−</button><input value="${it.quantity}" readonly aria-label="Quantité"><button type="button" data-change="${it.key}" data-qty="${it.quantity + 1}" aria-label="Plus">+</button></div></div>
        <div><div class="p">${money(it.final_line_price)}</div><button type="button" class="rm" data-change="${it.key}" data-qty="0">Retirer</button></div>
      </div>`).join("");
    }
    const t = $("#cart-total"); if (t) t.textContent = money(cart.total_price);
    const bar = $("#cart-shipbar"); if (bar) bar.style.width = cart.total_price > 0 ? "100%" : "0";
    const ck = $("#checkout"); if (ck) ck.disabled = !cart.items.length;
  }

  async function addToCart(form) {
    const btn = form.querySelector("[data-add]");
    const fd = new FormData(); fd.append("id", form.querySelector('input[name="id"]').value); fd.append("quantity", (form.querySelector('input[name="quantity"]') || { value: 1 }).value);
    btn && (btn.disabled = true);
    try {
      const r = await fetch(C.routes.cartAdd + ".js", { method: "POST", body: fd, headers: { Accept: "application/json" } });
      if (!r.ok) { const e = await r.json(); throw new Error(e.description || e.message || "Erreur"); }
      renderCart(await fetchCart()); openCart(); toast(btn ? btn.dataset.added || "Ajouté au panier" : "Ajouté au panier");
    } catch (e) { toast(e.message); }
    btn && (btn.disabled = false);
  }

  async function changeLine(key, qty) {
    const r = await fetch(C.routes.cartChange + ".js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ id: key, quantity: qty }) });
    renderCart(await r.json());
    if ($("[data-cart-page]")) location.reload();
  }

  document.addEventListener("click", e => {
    const t = e.target.closest("[data-open-cart],[data-close-cart],[data-change],[data-add]");
    if (!t) return;
    if (t.hasAttribute("data-open-cart")) { e.preventDefault(); openCart(); }
    else if (t.hasAttribute("data-close-cart")) closeCart();
    else if (t.hasAttribute("data-change")) changeLine(t.dataset.change, +t.dataset.qty);
    else if (t.hasAttribute("data-add")) { e.preventDefault(); addToCart(t.closest("form")); }
  });
  document.addEventListener("keydown", e => { if (e.key === "Escape") closeCart(); });
  $("#checkout")?.addEventListener("click", () => { location.href = "/checkout"; });

  /* ---------- Formulaire d'achat : variantes ---------- */
  $$("form[data-buy]").forEach(form => {
    let variants = [];
    try { variants = JSON.parse(form.querySelector("[data-variants]").textContent); } catch (e) {}
    const idInput = form.querySelector('input[name="id"]');
    const priceEl = form.querySelector("[data-price]");
    const img = form.closest("[data-product]")?.querySelector("[data-variant-img]");
    const lbl = form.querySelector("[data-variant-label]");
    const optionCount = +form.dataset.options || 1;

    function selected() {
      const vals = [];
      for (let i = 1; i <= optionCount; i++) {
        const sw = form.querySelector(`.swatch[data-option="${i}"][aria-checked="true"]`);
        const radio = form.querySelector(`input[data-option="${i}"]:checked`);
        vals.push(sw ? sw.dataset.value : radio ? radio.value : null);
      }
      return vals;
    }
    function update() {
      const vals = selected();
      const v = variants.find(x => vals.every((val, i) => val === null || x.options[i] === val)) || variants[0];
      if (!v) return;
      idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      $$("[data-sticky-price]").forEach(el => el.textContent = money(v.price));
      const btn = form.querySelector("[data-add]");
      if (btn) { btn.disabled = !v.available; btn.textContent = v.available ? btn.dataset.label : btn.dataset.soldout; }
      if (img && v.featured_image && v.featured_image.src) { img.style.opacity = 0; setTimeout(() => { img.src = v.featured_image.src; img.classList.remove("cover"); img.style.opacity = 1; }, 180); }
      // prix de chaque offre pour la couleur choisie
      $$("input[data-option][data-offer-price]", form).forEach(r => {
        const i = +r.dataset.option - 1, test = vals.slice(); test[i] = r.value;
        const m = variants.find(x => test.every((val, k) => val === null || x.options[k] === val));
        const p = form.querySelector(`[data-offer-price-for="${r.id}"]`); if (p && m) p.textContent = money(m.price);
      });
    }
    $$(".swatch", form).forEach(b => b.addEventListener("click", () => {
      $$(`.swatch[data-option="${b.dataset.option}"]`, form).forEach(x => x.setAttribute("aria-checked", x === b ? "true" : "false"));
      if (lbl) lbl.textContent = b.dataset.value;
      update();
    }));
    $$("input[data-option]", form).forEach(r => r.addEventListener("change", update));
    const q = form.querySelector('input[name="quantity"]');
    form.querySelector("[data-qty-dec]")?.addEventListener("click", () => q.value = Math.max(1, +q.value - 1));
    form.querySelector("[data-qty-inc]")?.addEventListener("click", () => q.value = Math.min(10, +q.value + 1));
    update();
  });

  /* ---------- Galerie page produit ---------- */
  $$(".thumbs button").forEach(b => b.addEventListener("click", () => {
    const main = $("[data-variant-img]"); if (!main) return;
    $$(".thumbs button").forEach(x => x.setAttribute("aria-current", x === b ? "true" : "false"));
    main.style.opacity = 0;
    setTimeout(() => { main.src = b.dataset.src; main.classList.toggle("cover", b.dataset.fit === "cover"); main.style.opacity = 1; }, 180);
  }));

  /* ---------- Héros : coloris ---------- */
  const heroImg = $("[data-hero-img]");
  $$("[data-hero-color]").forEach(b => b.addEventListener("click", () => {
    $$("[data-hero-color]").forEach(x => x.setAttribute("aria-checked", x === b ? "true" : "false"));
    const src = C.cutouts && C.cutouts[b.dataset.heroColor]; if (!src || !heroImg) return;
    heroImg.style.opacity = 0; setTimeout(() => { heroImg.src = src; heroImg.style.opacity = 1; }, 200);
  }));

  /* ---------- Menu mobile ---------- */
  $(".burger")?.addEventListener("click", () => $(".nav")?.classList.toggle("is-open"));

  /* ---------- Apparition ---------- */
  if ("IntersectionObserver" in window) {
    const io = new IntersectionObserver(es => es.forEach(x => { if (x.isIntersecting) { x.target.classList.add("in"); io.unobserve(x.target); } }), { threshold: .12 });
    $$(".reveal").forEach(el => io.observe(el));
  } else $$(".reveal").forEach(el => el.classList.add("in"));
  if (window.Shopify && Shopify.designMode) document.addEventListener("shopify:section:load", () => $$(".reveal").forEach(el => el.classList.add("in")));

  /* ---------- Toast ---------- */
  let tm;
  function toast(msg) {
    let el = $(".toast"); if (!el) { el = document.createElement("div"); el.className = "toast"; document.body.appendChild(el); }
    el.textContent = msg; el.classList.add("show"); clearTimeout(tm); tm = setTimeout(() => el.classList.remove("show"), 2600);
  }

  fetchCart().then(renderCart).catch(() => {});
})();
